module.exports = __webpack_public_path__ + "img/Meine_OESA_Logo.e70cea9e.svg";